import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectRolesArray } from '../../services/roles/selectors';

// Utils
import orderBy from '../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectOrderedData = createDeepEqualSelector(
    selectRolesArray,
    rolesArrayState => orderBy(rolesArrayState, 'name')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState =>
        orderedDataState.map(({ id, name }) => ({
            key: id,
            text: name,
            value: id
        }))
);

export { selectOrderedData, selectOptions };
